<template>
  <div class="page-shadow" :style="{ 'z-index': index }"></div>
</template>

<style scoped lang="scss">
.page-shadow {
  z-index: 2000;
  position: fixed;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>

<script>
export default {
  props: {
    index: {
      type: String,
      required: false,
      default: "2000"
    }
  }
};
</script>
